module.exports = __webpack_public_path__ + "img/locate-vending-machine-footer.0b9c4858.png";